import React from "react";
import { useLocalizedText } from "../../../utils/hooks/useLocalizedText";
import { Stack } from "react-bootstrap";
import { countryCodeMap } from "../../../Pages/Campaigns/data";
import { useCachedContext } from "@/utils/hooks/useCachedContext";

export const useOptions = () => {
  // ==========
  // hooks
  // ==========
  const { getLocalizedText, getLocalizedNumber } = useLocalizedText();
  // ==========
  // Query && Data
  // ==========
  const { isLoading, isFetching, getArray } = useCachedContext();

  const options = getArray("nationalities").map((country) => {
    return {
      q: country.q,
      value: country?.id,
      label: (
        <Stack direction="horizontal" gap={1} style={{ textWrap: "nowrap" }}>
          <i
            className={`flag-icon flag-icon-${countryCodeMap[
              country.id
            ]?.toLowerCase()}`}
          ></i>
          {[
            getLocalizedNumber(country.id),
            getLocalizedText(country?.name_ar, country?.name_en),
          ].join(" - ")}
        </Stack>
      ),
    };
  });

  return { options, isLoading };
};
